module.exports = __webpack_public_path__ + "img/full1-min.04bea104.png";